import Icon from '@ant-design/icons/lib/components/Icon';

import { CustomIconProps } from 'ui/icons/types';

const CrossSvg = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <title>cross icon</title>
    <path
      d="M18 6L6 18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 6L18 18"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CrossIcon = (props: CustomIconProps) => (
  <Icon component={CrossSvg} {...props} />
);

export default CrossIcon;
